import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';
import { SARDINE_ON_HOLD_CONSTANTS as types } from '@store/constants';
import { getErrorMessage } from '@utils';


export const getSardineOnHoldOrders =
  ({ searchReqData, ordersInPastHours, orderSubStatus }) =>
  async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_SARDINE_ON_HOLD_ORDERS,
    });

    const { data } = await api.orders.getSardineOnHoldOrders({
      orderSubStatus,
      ordersInPastHours,
      ...searchReqData
    });

    return dispatch({
      type: types.GET_SARDINE_ON_HOLD_ORDERS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch(
      setAlert({
        title: getErrorMessage({
          error,
          genericMessage: `Failed to get Sardine Onhold Orders orders!`
        }),
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: types.GET_SARDINE_ON_HOLD_ORDERS_FAILURE,
      payload: error
    });
  }
};

export const clearSardineOnHoldOrders = () => ({
  type: types.CLEAR_SARDINE_ON_HOLD_ORDERS
});
